import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import styles from "./styles/input.module.css";

function showClearButton(searchTerm, handleClick) {
  if (searchTerm) {
    return (
      <button
        className={styles.clear}
        onClick={() => handleClick('')}
        aria-label="clear selection"
      >
        <svg viewBox="0 0 10 10" width={11} stroke="#000000" strokeWidth="1px">
          <path d="M1,1 L10,10" />
          <path d="M10,1 L1,10" />
        </svg>
      </button>
    );
  }
  return null;
}

export function Input({ searchTerm, handleChange }) {
  const router = useRouter();
  const [term, setTerm] = useState(searchTerm);

  useEffect(() => {
    setTerm(searchTerm);
  }, [searchTerm])

  const onChange = (nextTerm) => {
      setTerm(nextTerm);
      handleChange(nextTerm);
  }

  return (
    <div className={styles.container}>
      <input
        className={styles.searchInput}
        type="text"
        onChange={(e) => onChange(e.currentTarget.value)}
        value={term}
        placeholder="Search for categories or products"
        aria-label="Search through site products"
        autoFocus
      />
      {showClearButton(term, onChange)}
    </div>
  );
}
